<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Engfinity Club' s Mega Event </h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class>
    <div class="section-lg">
        <div class="container">
            <h2>Engfinity Club' s Mega Event 2025</h2>
            <div class="text-justify">
                <p>Engfinity Club’s Mega Event at GHRCACS, Nagpur was a spectacular blend of innovation, teamwork, and creativity. Students showcased remarkable talent through engaging activities, inspiring sessions, and collaborative challenges, making it a truly memorable and enriching experience for all.</p>
            </div>
            <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity-club-2.png"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity-club-2.png"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity-club-3.png"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity-club-3.png"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity-club-4.png"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity-club-4.png"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>

            </div>

        </div>
    </div>
</section>
